import { User } from 'dashboard/models/user';
import { CurrentUserActions, CurrentUserActionType } from 'dashboard/redux/actions/current-user';

export interface CurrentUserState {
  currentUser: User;
  readmeJwtToken: string | undefined;
  impersonationMode: string | undefined;
  recoveryCode: string | undefined;
}

const initialState: CurrentUserState = {
  /* @ts-expect-error [strict-migration] The following line is not strict; please fix! */
  currentUser: undefined,
  readmeJwtToken: undefined,
  impersonationMode: undefined,
  recoveryCode: undefined,
};

export default (state: CurrentUserState = initialState, action: CurrentUserActions) => {
  switch (action.type) {
    case CurrentUserActionType.SaveCurrentUser: {
      return {
        ...state,
        currentUser: action.payload.user,
      };
    }

    case CurrentUserActionType.SaveReadmeJwtToken: {
      return {
        ...state,
        readmeJwtToken: action.payload.token,
      };
    }

    case CurrentUserActionType.SetImpersonationMode: {
      return {
        ...state,
        impersonationMode: action.payload.impersonationMode,
      };
    }

    case CurrentUserActionType.SetRecoveryCode: {
      return {
        ...state,
        recoveryCode: action.payload.recoveryCode,
      };
    }

    default:
      return state;
  }
};
